import React from 'react';

import GlobalStyle from './styles/GlobalStyle';
import NewHome from './pages/Mobile/';

function App() {
  return (
    <>
      <GlobalStyle />
      <NewHome />
    </>
  );
}

export default App;
